import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/siteInfo';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20abstract%20artistic%20scene%20with%20flowing%20golden%20light%20particles%20rising%20upward%20against%20a%20deep%20cream%20background%2C%20minimalist%20style%2C%20ethereal%20and%20dreamy%20atmosphere%2C%20inspirational%20mood%2C%20soft%20gradients%20of%20amber%20and%20warm%20white%2C%20cinematic%20composition%2C%20no%20text%20no%20people&width=1920&height=1080&seq=hero-bg-2026&orientation=landscape"
          alt="人人出彩"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 max-w-4xl mx-auto text-center pt-20">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 mb-8">
          <i className="ri-sparkling-line text-primary-400 text-sm"></i>
          <span className="text-xs md:text-sm text-background-50/90 font-medium">
            {siteInfo.stats.totalUsers} 位用户已加入
          </span>
        </div>

        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-tight mb-6">
          发现你的
          <span className="text-primary-400">闪光时刻</span>
        </h1>

        <p className="text-base md:text-lg text-background-50/75 max-w-2xl mx-auto mb-10 leading-relaxed">
          人人出彩致力于让每一个普通人都能展示自己的才华与故事。
          无论你是谁，无论你来自哪里，这里都有属于你的舞台。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/all"
            className="whitespace-nowrap px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm md:text-base hover:bg-primary-600 transition-all hover:scale-105 cursor-pointer"
          >
            探索出彩故事
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/about"
            className="whitespace-nowrap px-8 py-3.5 rounded-full bg-background-50/15 text-background-50 font-medium text-sm md:text-base border border-background-50/25 hover:bg-background-50/25 transition-all backdrop-blur-sm cursor-pointer"
          >
            了解更多
          </Link>
        </div>

        <div className="mt-16 flex flex-wrap items-center justify-center gap-8 md:gap-12">
          <div className="text-center">
            <p className="font-heading text-2xl md:text-3xl font-bold text-background-50">{siteInfo.stats.totalUsers}</p>
            <p className="text-xs md:text-sm text-background-50/60 mt-1">注册用户</p>
          </div>
          <div className="text-center">
            <p className="font-heading text-2xl md:text-3xl font-bold text-background-50">{siteInfo.stats.totalStories}</p>
            <p className="text-xs md:text-sm text-background-50/60 mt-1">出彩故事</p>
          </div>
          <div className="text-center">
            <p className="font-heading text-2xl md:text-3xl font-bold text-background-50">{siteInfo.stats.totalCategories}</p>
            <p className="text-xs md:text-sm text-background-50/60 mt-1">内容分类</p>
          </div>
        </div>

        <div className="mt-16">
          <a
            href="#categories"
            className="inline-flex flex-col items-center gap-2 text-background-50/60 hover:text-background-50 transition-colors cursor-pointer"
          >
            <span className="text-xs">向下滚动</span>
            <i className="ri-arrow-down-line text-lg animate-bounce"></i>
          </a>
        </div>
      </div>
    </section>
  );
}